<style lang="scss" src='./LocalWeather.scss' scoped></style>
<template src="./LocalWeather.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import GwExport from '@/components/gwExport/GwExport.vue';
import ApexChart from 'vue-apexcharts';
import VueHtml2pdf from 'vue-html2pdf';
import moment from 'moment';

import Datepicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import {
    getLocalWeatherReportData
} from '@/api/index';

import i18n from './../../../../i18n';

let CounterForUpdatesLines = 0;
let allReadingsArray = [];

const perPage = 100;
const pdfMaxWidth = 1120;
const chartWidth12 = "1050px";
const chartWidth6 = "500px";
const chartWidth4 = "350px";

export default {
    name: 'LocalWeather',
    extends: SecurityComponent,
    components: {
        ApexChart,
        VueHtml2pdf,
        GwExport,
        Datepicker
    },
    data() {
        return {
            chartMaxWidth12: '100%',
            chartMaxWidth6: '100%',
            chartMaxWidth4: '100%',
            selectedDateRange: null,
            stickyData: true,
            pdfName: null,
            loading: {
                temp: false,
                pressure: false,
                et_rate: false,
                humidity: false,
                wind_speed: false,
                uvi: false,
                visibility: false,
            },
            filters: {
                daysBack: null
            },
            temp_series: [],
            pressure_series: [],
            et_rate_series: [],
            humidity_series: [],
            wind_speed_series: [],
            uvi_series: [],
            visibility_series: [],
            options: [
                { text: this.$t('timePeriods.1DLong'), label: this.$t('timePeriods.last24H'), value: 1, },
                { text: this.$t('timePeriods.2DLong'), label: this.$t('timePeriods.last2D'), value: 2, },
                { text: this.$t('timePeriods.1WLong'), label: this.$t('timePeriods.lastWeek'), value: 7, },
                { text: this.$t('timePeriods.1MLong'), label: this.$t('timePeriods.lastMonth'), value: 30, },
                { text: this.$t('timePeriods.1YLong'), label: this.$t('timePeriods.lastYear'), value: 365, },
                { text: 'By Date', label: 'By Date', value: 0, }, 
            ],
            tempCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            pressureCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            et_rateCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            humidityCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            wind_speedCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            uviCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            visibilityCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            pagination: {
                page: 1,
                start: 0,
                end: 0
            },
            pdf: {},
        };
    },
    computed: {
        
    },
    methods: {
        getCsvData(){
            return [];
        },

        csvExport() {
            let csvContent = "data:text/csv;charset=utf-8,";
            let arrData = this.getCsvAllData();
            if(arrData.length > 0){
                csvContent += [
                    Object.keys(arrData[0]).join(","),
                    ...arrData.map(item => Object.values(item).join(","))
                ]
                    .join("\n")
                    .replace(/(^\[)|(\]$)/gm, "");

                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", this.pdfName + ".csv");
                link.click();
            }
        },

        getCsvAllData(){
            let readings = allReadingsArray;
            if(readings.length > 0){
                let data = [];
                readings.forEach((reading)=>{
                    let obj = {}
                            
                    obj[i18n.t('general.timeFrame')] = '';
                    
                    let reading_date = this.G_formatDate({date: (reading.reading_time), pretty: false});
                    obj[i18n.t('general.date')] = reading_date.replace(/,/g, "");
                    
                    let temperature = this.G_getMeasurement({ val: reading.temp, uom: this.consts.UOM.TEMP, addUnit: true, invertUOM: false })
                    obj[i18n.t('alerts.airTemperature')] = temperature.replace('°', '');
                    obj[i18n.t('uom.humidity')] = this.G_getMeasurement({ val: reading.humidity, uom: this.consts.UOM.HUMIDITY, addUnit: true, invertUOM: false });;
                    obj[i18n.t('uom.windSpeed')] = this.G_getMeasurement({ val: reading.wind_speed, uom: this.consts.UOM.WIND_SPEED, addUnit: true, invertUOM: false });;
                    obj[i18n.t('uom.pressure')] = this.G_getMeasurement({ val: reading.pressure, uom: this.consts.UOM.PRESSURE, addUnit: true, invertUOM: false });;
                    obj[i18n.t('uom.uv')] = this.G_getMeasurement({ val: reading.uvi, uom: this.consts.UOM.UNKNOWN, addUnit: true, invertUOM: false });;
                    obj[i18n.t('uom.visibility')] = this.G_getMeasurement({ val: reading.visibility, uom: this.consts.UOM.VISIBILITY, addUnit: true, invertUOM: false });;
                    obj[i18n.t('uom.etRate')] = this.G_getMeasurement({ val: reading.et_rate, uom: this.consts.UOM.ET_RATE, addUnit: true, invertUOM: false });;

                    data.push(obj);
                });
                
                let headers = [];
                let filters = this.getHeadersObj();
                headers.push(filters);
                return [...headers, ...data];
            }
            return [];
        },

        getHeadersObj(){
            let timeFrame = this.filters.daysBack.text;
            
            let obj = {}
            obj[i18n.t('general.timeFrame')] = timeFrame;
            obj[i18n.t('general.date')] = '';
            
            obj[i18n.t('alerts.airTemperature')] = '';
            obj[i18n.t('uom.humidity')] = '';
            obj[i18n.t('uom.windSpeed')] = '';
            obj[i18n.t('uom.pressure')] = '';
            obj[i18n.t('uom.uv')] = '';
            obj[i18n.t('uom.visibility')] = '';
            obj[i18n.t('uom.etRate')] = '';
            
            return obj
        },

        filterByDays(daysBack) {
            this.options[5].value = 0
            if(this.filters.daysBack != daysBack){
                this.selectedDateRange = null;
                this.setLoadingTrue();
                this.resetValues();
                this.filters.daysBack = daysBack;
                this.getGraph();
            }
        },

        async handleDateRangeChange(dates) {
            this.setLoadingTrue();
            this.resetValues();
            let date = null;
            this.options[5].value = 0
            if(dates[0]){                
                const startDate = moment(dates[0]).format('YYYY-MM-DD')
                const endDate = moment(dates[1]).format('YYYY-MM-DD')
                const start = new Date(startDate);
                const end = new Date(endDate);
                const timeDiff = Math.abs(end.getTime() - start.getTime());
                const days = Math.ceil(timeDiff / (1000 * 3600 * 24));
                this.filters.daysBack = this.options[5] 
                this.filters.daysBack.value = days
                date = {
                startDate, 
                endDate
            };
            
            }
            await this.getGraph(date);
            
        },

        resetValues() {            
            allReadingsArray = [];
            this.temp_series = [];
            this.pressure_series = [];
            this.et_rate_series = [];
            this.humidity_series = [];
            this.wind_speed_series = [];
            this.uvi_series = [];
            this.visibility_series = [];
            this.pagination= {
                page: 1,
                next: false
            }
        },
        
        exportReport(item){
            this.$refs.stationAlertPDF.generatePdf();
        },

        loadData() {
            this.setLoadingTrue();
            this.getGraph();
        },

        setLoadingTrue() {
            this.loading.temp = true;
            this.loading.pressure = true;
            this.loading.et_rate = true;
            this.loading.humidity = true;
            this.loading.wind_speed = true;
            this.loading.uvi = true;
            this.loading.visibility = true;
        },

        async getGraph(date){
            const daysBack = this.filters.daysBack;
            const resample = this.filters.daysBack.value == 7 ? '30min' : this.filters.daysBack.value == 30 ? '1h' : this.filters.daysBack.value == 365 ? '8h' : null;
            allReadingsArray = [];

            const data = {
                until: this.filters.daysBack.value,
                resampleFreq: resample,
            };

            if(date){
                data['startDate'] = date.startDate;
                data['endDate'] = date.endDate;
            }

            let apiCall = getLocalWeatherReportData;
            
            await apiCall(data).then((res) => {
                
                allReadingsArray = res;

                this.getTempData(res, daysBack);
                this.getHumidityData(res, daysBack);
                this.getPressureData(res, daysBack);
                this.getWindSpeedData(res, daysBack);
                this.getUVData(res, daysBack);
                this.getVisibilityData(res, daysBack);
                this.getETRateData(res, daysBack);

            });
        },

        getTempData(res, daysBack) {
            this.loading.temp = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'TEMP'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['temp'],
                                uom: 'TEMP',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.temp_series.push({
                        name: i18n.t('alerts.airTemperature'),
                        data: tempSeries
                    });
                }

            } else {
                console.log('overwrite prevented for getTempData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.tempCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.tempCharOpt = tempCharOpt;
            }

            this.loading.temp = false;
        },

        getHumidityData(res, daysBack) {
            this.loading.humidity = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'HUMIDITY'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['humidity'],
                                uom: 'HUMIDITY',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.humidity_series.push({
                        name: i18n.t('uom.humidity'),
                        data: tempSeries
                    });
                }

            } else {
                console.log('overwrite prevented for getHumidityData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.humidityCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.humidityCharOpt = tempCharOpt;
            }

            this.loading.humidity = false;
        },

        getPressureData(res, daysBack) {
            this.loading.pressure = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'PRESSURE'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['pressure'],
                                uom: 'PRESSURE',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.pressure_series.push({
                        name: i18n.t('uom.pressure'),
                        data: tempSeries
                    });
                }

            } else {
                console.log('overwrite prevented for getPressureData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.pressureCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.pressureCharOpt = tempCharOpt;
            }

            this.loading.pressure = false;
        },

        getWindSpeedData(res, daysBack) {
            this.loading.wind_speed = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'WIND_SPEED'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['wind_speed'],
                                uom: 'WIND_SPEED',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.wind_speed_series.push({
                        name: i18n.t('uom.windSpeed'),
                        data: tempSeries
                    });
                }

            } else {
                console.log('overwrite prevented for getWindSpeedData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.wind_speedCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.wind_speedCharOpt = tempCharOpt;
            }

            this.loading.wind_speed = false;
        },

        getUVData(res, daysBack) {
            this.loading.uvi = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'UNKNOWN'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['uvi'],
                                uom: 'UNKNOWN',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.uvi_series.push({
                        name: i18n.t('uom.uv'),
                        data: tempSeries
                    });
                }

            } else {
                console.log('overwrite prevented for getUVData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.uviCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.uviCharOpt = tempCharOpt;
            }

            this.loading.uvi = false;
        },

        getVisibilityData(res, daysBack) {
            this.loading.visibility = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'VISIBILITY'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['visibility'],
                                uom: 'VISIBILITY',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.visibility_series.push({
                        name: i18n.t('uom.visibility'),
                        data: tempSeries
                    });
                }

            } else {
                console.log('overwrite prevented for getVisibilityData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.visibilityCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.visibilityCharOpt = tempCharOpt;
            }

            this.loading.visibility = false;
        },

        getETRateData(res, daysBack) {
            this.loading.et_rate = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'ET_RATE'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['et_rate'],
                                uom: 'ET_RATE',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.et_rate_series.push({
                        name: i18n.t('uom.etRate'),
                        data: tempSeries
                    });
                }

            } else {
                console.log('overwrite prevented for getETRateData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.et_rateCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.et_rateCharOpt = tempCharOpt;
            }

            this.loading.et_rate = false;
        },
        
        getLinesChartOptions() {
            return {
                chart: {
                    type: 'line',
                    animations: {
                        enabled: false,
                    },

                    stacked: false,
                    height: 350,
                    zoom: {
                        type: 'x',
                        enabled: false,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        show: false
                    },
                    events: {
                        updated: function (chartContext, config) {
                            if (CounterForUpdatesLines != 0) {
                                var elmnt = document.getElementById("chart");
                                if (elmnt) {
                                    elmnt.scrollIntoView();
                                }
                            }
                            ++CounterForUpdatesLines;
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: '',
                    align: 'left'
                },
                stroke: {
                    width: 5
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            return val ? (val).toFixed(2) : 0;
                        },
                    },
                    title: {
                        text: 'unitOfMeasurament'
                    },
                    min: (min) => {
                        return min - 2
                    },
                    max: (max) => {
                        return max + 2
                    },
                },
                xaxis: {
                    type: 'datetime',
                    labels: {
                        datetimeUTC: false,
                        datetimeFormatter: {
                            year: 'yyyy',
                            month: "MMM 'yy",
                            day: 'dd MMM',
                            hour: 'h:mm TT',
                        },
                    }
                },
                tooltip: {
                    x: {
                        show: true,
                        formatter: (val) => {
                            return this.G_formatDate({date: val, pretty: false});
                        }
                    },
                    shared: false,
                    y: {
                        formatter: (val) => {
                            return val ? `${(val).toFixed(2)}` : '';
                        }
                    }
                }
            }
        },

        async beforePDF({ html2pdf, options, pdfContent }){
            let container = this.$refs.reportContainer;
            let currentWidth = container.getBoundingClientRect().width;

            if(currentWidth >= pdfMaxWidth){
                this.chartMaxWidth12 = chartWidth12;
                this.chartMaxWidth6 = chartWidth6;
                this.chartMaxWidth4 = chartWidth4;
            }

            let date = new Date();
            this.pdf.date = moment(date).format("MM-DD-YYYY");
            this.pdf.time = this.filters.daysBack.text;

            this.stickyData = false;

            await html2pdf().set(options).from(pdfContent).toPdf().save();

            this.chartMaxWidth12 = "100%";
            this.chartMaxWidth6 = "100%";
            this.chartMaxWidth4 = "100%";
            this.stickyData = true;
        },

    },

    created() {
        let date = new Date();
        date = moment(date).format("MM-DD-YYYY");
        this.pdfName = i18n.t('general.localWeather') + ' ' + date;
    },

    async mounted() {
        allReadingsArray = [];
        this.filters.daysBack = this.options[0];
        this.loadData();
    },
};

</script>
